module.exports = __webpack_public_path__ + "static/media/tools-question.0cac1ab4.svg";